export const ACTION_PREFIX = '@komigen/payments-beta';
export const DEPOSIT_QUERY_KEY = 'deposit';
export const SKIP_AMOUNT_SUGGESTION_KEY = 'SKIP_AMOUNT_SUGGESTION';
export const DEPOSIT_SCHUFA_KEY = 'deposit-schufa-check-key';
export const CREDIT_CARD_BLACKLISTED_KEY = 'credit-card-blacklisted-key';
export const PAYEMENT_TRACK_EVENT = 'deposit_flow';
export const INITIAL_META = 'initial-meta';
export const SITE = 'site';
export const SHOW_FIRST_DEPOSIT_SKIP_BUTTON = 'showFirstDepositSkipButton';

export enum StaleTime {
	ZERO = 0,
	SHORT = 1 * 60 * 1000,
	MODERATE = 5 * 60 * 1000,
	LONG = 15 * 60 * 1000,
	VERY_LONG = 60 * 60 * 1000
}

export enum ResponseStatus {
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE'
}

export enum SendHandlerType {
	SEND_HANDLER_CONTROLLER = 'SEND_HANDLER_CONTROLLER',
	EXTERNAL_WINDOW = 'EXTERNAL_WINDOW',
	EXTERNAL_PANEL = 'EXTERNAL_PANEL',
	RESULT_AFTER_SINGLE_CALL = 'RESULT_AFTER_SINGLE_CALL',
	NATIVE_APP = 'NATIVE_APP'
}

export enum ButtonVariants {
	primary,
	secondary,
	applePay,
	support
}

export enum ButtonTypes {
	submit = 'submit',
	button = 'button'
}

export enum StepRoutes {
	bonus = 'bonus',
	methods = 'methods',
	templates = 'templates',
	amount = 'amount',
	execute = 'execute'
	/* results = 'results' */
}

export enum LimitType {
	DEFAULT,
	DEPOSIT,
	WAGER,
	SPEND,
	TIME,
	ACCUMULATED_LOSS,
	LOSS,
	SOW_AML_SPENDING_DEPOSIT_LIMIT,
	BALANCE_LIMIT
}

/**
 * Templates enum
 */
export enum Templates {
	NO_FIELDS,
	SWISH,
	FOGHORN_DEPOSIT,
	EMAIL,
	EMAIL_CURRENCIES,
	EMAIL_MONEYBOOKERS,
	ONLY_CURRENCIES,
	PHONE,
	CREDIT_CARD,
	VIRTUAL_CREDIT_CARD,
	PEER_TO_PEER,
	EMP_CASHLIB,
	IMOJE_BANK,
	NETELLER,
	ECOBANQ,
	EZEE_WALLET,
	PAYMERO,
	PAYMERO_UPI,
	AKONTO_PAY_UPI,
	MUCHBETTER,
	PAY_BLIK,
	TSI_VOUCHER,
	VENUSPOINT_DEPOSIT
}

export const FormTemplateCode = {
	CREDIT_CARD: 'CREDIT-CARD',
	DIRECTLY_ROUTED_CC: 'DIRECTLY-ROUTED-CREDIT-CARD',
	ASTROPAY_CC: 'ASTROPAY-CREDIT-CARD',
	CRED_CARD: 'CRED-CARD',
	NETELLER: 'NETELLER',
	ECOBANQ: 'ECOBANQ',
	EZEE_WALLET: 'EZEE_WALLET',
	VENUSPOINT_DEPOSIT: 'VENUSPOINT_DEPOSIT',
	SWISH: 'SWISH',
	IMOJE_BANK: 'IMOJE_BANK',
	PAYMERO_NET_BANKING: 'PAYMERO_NET_BANKING',
	AKONTO_PAY_NET_BANKING: 'AKONTO_PAY_NET_BANKING',
	ZOTAPAY_NET_BANKING: 'ZOTAPAY_NET_BANKING',
	SAFEXPAY_NETBANKING: 'SAFEXPAY_NETBANKING',
	PAYMERO_WALLET: 'PAYMERO_WALLET',
	DOTPAY_BLIK: 'DOTPAY-BLIK',
	TPAY_BLIK: 'TPAY-BLIK',
	TSI: 'TSI',
	VOUCHER: 'VOUCHER',
	EMAIL: 'EMAIL',
	EMAIL_CURRENCIES: 'EMAIL-CURRENCIES',
	ONLY_CURRENCIES: 'ONLY-CURRENCIES',
	EMAIL_MONEYBOOKERS: 'EMAIL_MONEYBOOKERS',
	PHONE: 'PHONE',
	VIRTUAL_CREDIT_CARD: 'VIRTUAL-CREDIT-CARD',
	PEER_TO_PEER: 'PEER-TO-PEER',
	EMP_CASHLIB: 'EMP_CASHLIB',
	PAYMERO_UPI: 'PAYMERO_UPI',
	AKONTO_PAY_UPI: 'AKONTO_PAY_UPI',
	MUCHBETTER: 'MUCHBETTER'
};

export enum DepositType {
	QUICK_DEPOSIT = 1,
	NORMAL_DEPOSIT = 2,
	DEPOSIT_LOGIN = 3,
	QUICK_DEPOSIT_SB = 4
}

export enum ExecuteFlowType {
	CASHIER = 'CASHIER',
	QD = 'QD'
}
